<template>
  <div
    class="g-basic-article-box news_list_item_line jz_hover jz_theme_font_hover_color"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)"
    :style="{
      ...style
    }"
    :data-type="type"
    :data-device="getDevice"
  >
  <span @click.stop="templet.is_jump({href,target:jumpWay === 'newWindow' ? '_blank' : '_self'})" class="news_list_item_link" >
    <div
      class="news_list_item_inner animationBox"
      ref="animationBox"
      :style="{
        ...box_shadow,
        ...getBackgroundStyle,
        borderRadius: module.data.pc_widgets_infor.borderRadius[module.data.pc_widgets_infor.borderRadius.radio_val].value + 'px',
        '--seBgColor':seBgColor
    }"
      @mouseenter="(e) => { templet.enter_animation(img_effects, e.target, $store.state.app.view_pattern) }"
      @mouseleave="(e) => { templet.leave_animation(img_effects, e.target) }"
    >
      
        <div
          class="news_list_img_box"
          v-if="type === '1' || type === '2' || (type === '3' && index === 0) || type === '4'"
          :style="imgBoxStyle"
        >
          <div class="news_list_img" :style="imgConStyle" data-was-processed="true">
            <img
              class="animationImg u-img"
              :alt="dataBackup.title"
              :title="dataBackup.title"
              :style="imgStyle"
              :src="dataBackup.imgSrc"
              @click.stop="templet.is_jump({href,target: jumpWay === 'newWindow' ? '_blank' : '_self'})"
            />
          </div>
        </div>
        <div class="news_list_item_content">
          <div class="news_list_item_header" :style="{
            justifyContent: (this.type == 1 || this.type == 4) ? this.flexAlign(this.pc_infor.textAlign) : ''
          }">
            <component
              :is="isSystem ? 'h2' : 'p'"
              class="news_list_item_title jz_hover jz_theme_font_hover_color"
              :style="{
                ...getFontStyle,
                '--theme_color': theme_color,
                'lineHeight': fromTag !== 'search' ? (this.pcInforFont.fontSize + 10) + 'px' : '',
              }"
            >{{ dataBackup.title }}</component>
            <span
              class="news_list_item_date"
              :style="{
                ...getFontStyle,
                'lineHeight': fromTag !== 'search' ? (this.pcInforFont.fontSize + 10) + 'px': '',
                'opacity': 0.8,
                'fontSize': fromTag !== 'search' ? (this.pcInforFont.fontSize - 2) + 'px' : '',
                'fontWeight': 'normal',
                'fontStyle': 'normal',
                'textDecoration': 'none'
              }"
              v-if="showSet.find(item => item === 'date')"
            > {{ dataBackup.date }}</span>
          </div>
          
          <div
            class="news_list_item_summery"
            v-if="showSet.indexOf('summary') != -1"
            :style="{
              ...getFontStyle,
              'lineHeight': 1.7,
              'opacity': 0.8,
              'fontSize': fromTag !== 'search' ? (this.pcInforFont.fontSize - 2) + 'px' : '',
              'fontWeight': 'normal',
              'fontStyle': 'normal',
              'textDecoration': 'none',
            }"
            >{{ dataBackup.content }}
          </div>
          <div class="news_list_item_ext_line" v-if="type !== '4'">
            <div class="news_list_item_group" v-if="showSet.find(item => item === 'type') && dataBackup.type !== ''">
              <span
               @click.stop="templet.is_jump({href:typeHref,target:jumpWay === 'newWindow' ? '_blank' : '_self'})"
                class="news_list_item_group_item"
              >{{ dataBackup.type }}</span>
            </div>
            <div class="news_list_item_arrow_link" v-if="type === '1' && isPc && showSet.indexOf('button') != -1">
              <div class="news_list_item_arrow"></div>
            </div>
          </div>

          <div class="view_detail_contain" v-if="type === '4'  && showSet.indexOf('button') != -1">

            <detail_button :item="dataBackup" :module="module" v-if="!pc_infor.button_text.isHidden"></detail_button>

            <span class="view_detail"v-if="false" >{{ getLang($t('widgets_basic_article_list_components_basic_article_421'))}} </span>
          </div>
        </div>
     
    </div>
  </span>

  <div class="tooptipPart" v-if="isHover && isPc && !hideBtn">
    <my_edit_btn cover-click @click="edit" :title="$t('widgets_basic_article_info_index_354')"></my_edit_btn>
    <my_close_btn v-if="!isSystem && !(listArr.type_system !== undefined && ['article', 'help', 'case', 'product'].includes(this.$route.name))" cover-click @click="close" :title="$t('widgets_basic_article_list_components_basic_article_420')"></my_close_btn>
  </div>

    <basic_addArticle
      :article-type="dataBackup._type"
      :edit-id="dataBackup.id"
      v-if="showAddArticle"
      @closed="closeAddArticle"
      @submit_sure="submitSure"
    ></basic_addArticle>
  </div>
</template>

<script>
import i18n from '../../../language/index'

import {getBoxShadowStyle} from '@/utils/utils'
import {font_set} from '@/base/background_set'
import detail_button from "./detail_button";

export default {
  name: 'basic_article',
  components: {
    detail_button
  },
  data() {
    return {
      isHover: false,
      showAddArticle: false,
      isSystem: this.module.data.isSystem === 'true' ? true : false,
      dataBackup: {}
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    data: {
      type: Object,
      default: () => {
        return {
          // index: 2,
          // imgSrc: 'https://preapiconsole.71360.com/file/read/www/M00/01/60/wKgBbF5BC4mAcmJ4AAJaYY17MEI015.jpg',
          // title: '设计师JCY进行设计交流',
          // content: '品经理考虑要做什么产品才有价值，交互设计师考虑怎么把这个想法有效的转化成一系列的界面展现给用户。除了展现，还有和用户的交互。这个展现、交互的过程就需要一定的表达能力。这种表达能力并不是我们平时所特指的口头表达，而是使用网页语言表达。我们经常...',
          // date: '2019-12-29',
          // type: '技术文章',
          // typeId: 3',
          // viewing: 23
        }
      }
    },
    type: { // 模块类型
      type: String,
      default: () => '1'
    },
    index: {
      type: Number,
      default: 0
    },
    showSet: { // 显示的额外字段
      type: Array,
      default: () => []
    },
    imgHeight: { // 图片高度
      type: String,
      default: '100%'
    },
    imgWidth: { // 图片宽度
      type: String,
      default: '100%'
    },
    rol: { // 每行多少个
      type: Number,
      default: 4
    },
    hideBtn: { // 隐藏按钮
      type: Boolean,
      default: false
    },
    jumpWay: { // 跳转方式
      type: String,
      default: 'newWindow'
    },
    imgZoom: { // 图片缩放
      type: String,
      default: 'default'
    },
    marginTop: {
      type: Number,
      default: 0
    },
    marginBottom: {
      type: Number,
      default: 0
    },
    marginLeft: {
      type: Number,
      default: 10
    },
    marginRight: {
      type: Number,
      default: 0
    },
    marginModule: {
      type: String,
      default: 'equal' // equal（等距） free（自由）
    },
    fromTag: { // 是否为全局搜索挂件
      type: String,
      default: ''
    }
  },
  computed: {
    style() {
      let obj = {
        '--theme_color': this.theme_color
      }
      if (this.isMobile) {
        if (this.type === '1') {
          obj.width = (100 - Number(this.rol) * 1.8229 * 2) / Number(this.rol) + '%'
        }
        return obj
      }
      if (this.type === '1') {
        obj.width = 'calc(' + (100 / Number(this.rol)) + '%' + ' - 0px)'
      }
      console.log('marginModule123', this.marginModule);
      if (this.marginModule === 'equal') {
        if (this.marginTop && this.marginLeft) {
          obj.margin = this.marginTop / 2 + 'px ' + this.marginLeft / 2 + 'px';
          // obj.width = 'calc(' + (100 / Number(this.rol)) + '%' + ' - ' +(this.marginLeft)  + 'px)'
        }
      }
      if (this.marginModule === 'free') {
        if (this.marginTop && this.marginRight && this.marginBottom && this.marginLeft) {
          obj.margin = this.marginTop + 'px ' + this.marginRight + 'px ' + this.marginBottom + 'px ' + this.marginLeft + 'px';
          // obj.width = 'calc(' + (100 / Number(this.rol)) + '%' + ' - ' +(this.marginRight+this.marginLeft)  + 'px)'
        }
      }
      if (String(this.pc_infor.moduleStyle) !== '0') {
        if (this.pc_infor.padding) {
          obj.paddingTop = this.pc_infor.padding[this.pc_infor.padding.radio_val].paddingTop / 2 + 'px'
          obj.paddingBottom = this.pc_infor.padding[this.pc_infor.padding.radio_val].paddingTop / 2 + 'px'
          obj.paddingLeft = this.pc_infor.padding[this.pc_infor.padding.radio_val].paddingLeft / 2 + 'px'
          obj.paddingRight = this.pc_infor.padding[this.pc_infor.padding.radio_val].paddingLeft / 2 + 'px'
        }
      }
      if (this.fromTag === 'search' && this.listArr.styleType === 'type2') {
        obj.padding = obj.margin
        obj.margin = '0px'
      }
      return obj
    },
    imgConStyle() {
      const style = {
        // backgroundImage: 'url(' + this.data.imgSrc + ')'
      }
      // if (this.isPc)
      style.paddingTop = this.imgHeight
      return style
    },
    imgStyle() {
      const style = {}
      if (this.imgZoom === 'cover') style.objectFit = 'cover'
      if (this.imgZoom === 'auto') style.objectFit = 'contain'
      return style
    },
    imgBoxStyle() {
      if ((this.type === '2' || this.type === '3') && this.isPc) return {width: this.imgWidth}
      return {}
    },
    isMobile() {
      return this.$store.state.app.view_pattern === 'mb'
    },
    isPc() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    href() {
      if (this.data._type === 1 || this.data._type === 'article') return `#/article?${this.linkParam(this.data)}`
      // `#/article?id=${this.data.id}&tag_id=${this.data.tag_ids}`
      //'#/article?id=' + this.data.id // 新闻
      if (this.data._type === 2 || this.data._type === 'help') return `#/help?${this.linkParam(this.data)}`
      // `#/help?id=${this.data.id}&tag_id=${this.data.tag_ids}`
      // '#/help?id=' + this.data.id // 帮助
      if (this.data._type === 3 || this.data._type === 'case') return `#/case?${this.linkParam(this.data)}`
      // `#/case?id=${this.data.id}&tag_id=${this.data.tag_ids}`
      // '#/case?id=' + this.data.id // 案例
    },
    is_road_type() {
      return this.$store.getters['app/is_road_type']
    },
    linkParam() { // 外贸站的存在标签ID
      return item => {
        let path = `id=${item.id}`
        return this.is_road_type ? `${path}&tag_id=${item.tag_ids}` : path
      }
    },
    typeHref() {
      if (this.data._type === 1 || this.data._type === 'article') return '#/article_index?typeId=' + this.data.typeId // 新闻
      if (this.data._type === 2 || this.data._type === 'help') return '#/help_index?typeId=' + this.data.typeId // 帮助
      if (this.data._type === 3 || this.data._type === 'case') return '#/case_index?typeId=' + this.data.typeId // 案例
    },
    getDevice() {
      return this.$store.state.app.view_pattern
    },
    img_effects() {
      return this.module.data.img_effects
    },
    theme_color() {
      return this.$store.state.myRender.common.theme_color
    },
    getBackgroundStyle(){
      if (this.fromTag === 'search') {
        if(this.listArr.styleType === 'type2'){
          return {...this.$utils.getBackground(this.pc_infor.background)}
        }
      }else{
        return {...this.$utils.getBackground(this.pc_infor.background)}
      }
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor
    },
    box_shadow() { // 阴影设置 只有PC端才能有阴影 其他的不存在
      return this.$store.state.app.view_pattern === 'pc' && (this.fromTag !== 'search'  || (this.fromTag === 'search' && this.listArr.styleType === 'type2') )
      ? (this.isHover ? getBoxShadowStyle(this.pc_infor.boxShadow, 'hover')
       : getBoxShadowStyle(this.pc_infor.boxShadow)) : {}
    },
    summery_slice() {
      return function (content) {
        return content.length > this.pc_infor.descNum ? this.data.content.substring(0, this.pc_infor.descNum) + '...' : this.data.content
      }
    },
    seBgColor() { // 悬浮背景色 z在初始化的时候加了悬浮的背景色
      if(this.fromTag === 'search'){
        if(this.listArr.styleType === 'type2'){
          return this.pc_infor.background[this.pc_infor.background.radio_val].seColor
        }
      }else{
        return this.pc_infor.background[this.pc_infor.background.radio_val].seColor
      }
      // return  this.fromTag !== 'search' ? this.pc_infor.background[this.pc_infor.background.radio_val].seColor : ''
    },
    getFontStyle() {
      if(!(this.pc_infor && this.pc_infor.font)) {
        return
      }
      let ret = font_set(this.pc_infor.font)
      if(this.type == 1 || this.type == 4){
        ret.textAlign = this.pc_infor.textAlign
      }
      // return font_set(this.pc_infor.font)
      return ret
    },
    pcInforFont() {
      if(!(this.pc_infor && this.pc_infor.font)) {
        return
      }
      return this.pc_infor.font[this.pc_infor.font.radio_val]
    },
    listArr() {
      return this.module.data.listArr
    },
  },
  watch: {
    data() {
      this.dataBackup = {
        ...this.data,
        imgSrc: this.data.imgSrc || require('./../../../../static/image/noimage.jpg'),
        // content: this.data.content.length > 60 ? this.data.content.substring(0, 60) + '...' : this.data.content
      }
    },
    type(val) {
      this.$nextTick(() => {
        this.templet.initImageAnimation(this.img_effects, this.img_effects, this.$refs.animationBox, this.$store.state.app.view_pattern)
      })
    }
  },
  created() {
    this.dataBackup = {
      ...this.data,
      imgSrc: this.data.imgSrc || require('./../../../../static/image/noimage.jpg'),
      // content: this.data.content.length > 60 ? this.data.content.substring(0, 60) + '...' : this.data.content
    }
  },
  mounted() {
    console.log('this.marginTop:', this.marginTop)
    this.templet.initImageAnimation(this.img_effects, this.img_effects, this.$refs.animationBox, this.$store.state.app.view_pattern)
  },
  methods: {
    toPath(href, type) {
      if (type === '_blank') {
        window.open(href)
      } else if (type === '_self') {
        window.location.href = href
      }
    },
    module_isHover(val) {
      this.isHover = val
    },
    close() {
      this.$confirm(i18n.t('widgets_basic_article_list_components_basic_article_422'), i18n.t('view_public_topbar_23'), {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        type: 'warning'
      }).then(() => {
        this.$message({
          type: 'success',
          message: i18n.t('widgets_basic_article_list_components_basic_article_423')
        })
        this.$emit('close', this.data.id)
      })
    },
    edit() {
      this.showAddArticle = true
      this.$store.state.main_dialog.main_dialog_isShow = false
    },
    closeAddArticle() {
      this.showAddArticle = false
    },
    submitSure(id) {
      this.$emit('update', id, this.index)
    },
    flexAlign(str){
      let obj = {
        'left' : 'flex-start',
        'center' : 'center',
        'right' : 'end',
      }
      return obj[str]
    }
    
  }
}
</script>

<style lang="scss" scoped>
.g-basic-article-box {
  position: relative;

  .jz_hover.jz_theme_font_hover_color .news_list_item_inner:hover{
    color: var(--theme_color);
  }

  &.jz_hover.jz_theme_font_hover_color .news_list_item_inner:hover  
    .news_list_item_inner
    .news_list_item_content
    .news_list_item_header h4{    
    color: var(--theme_color) !important;
  }

  .tooptipPart {
    top: auto;
    bottom: 0;
    right: 0;
    display: block;
    z-index: 999;
  }

  &.news_list_item_line {
    position: relative;
    transition: all 0.4s ease-out;
    box-sizing: border-box;

    //&[data-device="pc"]:hover {
    //  box-shadow: rgba(0, 0, 0, 0.12) 0 0 22px;
    //}
    .news_list_item_inner:hover{
      background-color:var(--seBgColor) !important;
    }
  }

  &[data-type="0"],
  &[data-type="3"] {
    // padding: 30px;
    //margin: 20px;
    padding: 10px;
  }

  &[data-type="0"] {
    padding: 10px;

    .news_list_item_inner {
      padding: 10px;
    }
  }


  &[data-type="1"] {
    width: calc(25% - 20px);
    padding-left: 0;
    padding-right: 0;
    display: inline-block;
    vertical-align: top;
    //background: #fff;
    border-radius: 6px;
    overflow: hidden;
  }

  &[data-type="1"] {
    //margin-right: 10px;
    //margin-left: 10px;
    padding-top: 0;
    //margin-top: 24px;
    padding-bottom: 0;
  }

  &[data-type="4"] {
    //margin-right: 10px;
    //margin-left: 10px;
    padding-top: 0;
    //margin-top: 24px;
    margin-top: 0;
    margin-bottom: 24px;
    padding-bottom: 0;
  }

  &[data-type="4"] {
    width: calc(100% - 24px);
    height: 100%;
    padding-left: 0;
    padding-right: 0;
    display: inline-block;
    vertical-align: top;
    background: #fff;
    border-radius: 0;
    overflow: hidden;
  }

  &[data-device="mb"][data-type="4"] {
    width: 45%;
    margin: 0;
  }

  &[data-type="2"] {
    // padding: 30px;
    //margin: 20px;
    padding: 10px;
  }

  &[data-type="2"] .news_list_item_inner {
    padding-right: 10px;
  }

  &[data-type="3"] .news_list_item_inner {
    padding: 10px;
  }

  &[data-device="mb"][data-type="1"].news_list_item_line {
    width: 46.3542%;
    margin-left: 1.8229%;
    margin-right: 1.8229%;
    margin-top: 20px;
    padding: 0 0 6px 0;
  }

  &[data-device="mb"].news_list_item_line {
    margin-left: 3.72%;
    margin-right: 3.6458%;
    padding: 20px 0;
  }

  &[data-device="mb"][data-type="4"].news_list_item_line {
    margin: 0;
    padding: 0;
  }

  .news_list_item_link {
    // position: absolute;
    // top: 0;
    // left: 0;
    // width: 100%;
    // height: 100%;
    // z-index: 1;
  }

  .news_list_item_inner {
    display: flex;
    box-sizing: border-box;
    flex: 1;
    height: 100%;
    background: #fff;
  }

  &[data-type="1"] .news_list_item_inner {
    display: block;
    padding-left: 0;
    padding-right: 0;
    padding-top: 5%;
    padding-bottom: 5%;
  }

  &[data-type="4"] .news_list_item_inner {
    display: block;
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
    padding-bottom: 5%;
  }


  .news_list_img_box {
    display: flex;
    align-items: flex-start;
    width: 38%;
    max-width: 100%;
    margin-right: 30px;
    overflow: hidden;
    flex-shrink: 0;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &[data-type="1"] .news_list_img_box {
    width: 90%;
    margin: 0 auto;
    overflow: hidden;
  }

  &[data-type="4"] .news_list_img_box {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
  }

  &[data-device="mb"] .news_list_img_box {
    flex-shrink: 1;
  }

  &[data-device="mb"][data-type="2"] .news_list_img_box,
  &[data-device="mb"][data-type="3"] .news_list_img_box {
    flex-shrink: 0;
  }

  &[data-device="mb"] .news_list_img_box {
    /*width: 126px;*/
    margin-right: 12px;
  }

  &[data-device="mb"][data-type="1"] .news_list_img_box {
    margin-right: auto;
  }

  &[data-device="mb"][data-type="4"] .news_list_img_box {
    margin-right: auto;
    width: 90%;
  }

  &[data-device="mb"][data-type="4"] .news_list_img {
    padding-top: 100% !important;
  }

  .news_list_img {
    margin-right: 0;
    position: relative;
    width: 100%;
    height: 0;
    background: no-repeat center;
    background-size: cover;
    transition: all 0.36s ease;
  }

  .u-img {
    cursor: pointer;
  }

  &[data-type="1"] .news_list_img {
    padding-top: 52.631%;
    margin-right: 0;
    position: relative;
  }

  &[data-type="4"] .news_list_img {
    padding-top: 52.631%;
    margin-right: 0;
    position: relative;
  }

  &[data-device="mb"][data-type="2"] .news_list_img {
    padding-top: 81%;
  }

  &[data-device="mb"][data-type="3"] .news_list_img {
    padding-top: 81%;
  }

  &[data-device="mb"] .news_list_img {
    width: 100%;
    height: 0;
  }

  .news_list_item_content {
    width: 100%;
    box-sizing: border-box;
    -webkit-box-flex: 1;
    flex-grow: 1;
  }

  &[data-type="1"] .news_list_item_content {
    padding-left: 5%;
    padding-right: 5%;
  }

  &[data-type="4"] .news_list_item_content {
    padding-left: 5%;
    padding-right: 5%;
  }

  .news_list_item_header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    margin-top: 0;
  }


  &[data-type="4"] .news_list_item_header {
    display: flex;
    align-items: flex-end;
  }

  &[data-type="4"] .news_list_item_title {
    // width: auto !important;
  }

  &[data-type="0"] .news_list_item_header,
  &[data-type="3"] .news_list_item_header {
    flex-wrap: nowrap;
  }

  &[data-type="2"] .news_list_item_header {
    margin-top: 20px;
    flex-wrap: nowrap;
  }

  &[data-type="4"] .news_list_item_header {
    color: #333;
  }

  &[data-device="mb"] .news_list_item_header {
    display: block;
    margin-top: 0;
  }

  .news_list_item_title {
    width: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #333;
    font-family: Arial;
    line-height: 1;
    word-break:normal;
    margin: 0;
  }

  &[data-type="1"] .news_list_item_title {
    margin-top: 20px;
  }

  &[data-type="4"] .news_list_item_title {
    margin-top: 20px;
    font-weight: bold;
  }

  &[data-device="mb"] .news_list_item_title {
    // margin-top: 10px;
    font-size: 14px;
    display: -webkit-box;
    // max-height: 40px;
    line-height: 1.5;
    -webkit-line-clamp: 2;
    -o-text-overflow: -o-ellipsis-lastline;
    text-overflow: -o-ellipsis-lastline;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
  }

  .news_list_item_date {
    font-size: 14px;
    color: #333;
    font-family: Arial;
    line-height: 24px;
  }

  &[data-type="0"] .news_list_item_date,
  &[data-type="3"] .news_list_item_date {
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    margin-left: 30px;
  }

  &[data-type="2"] .news_list_item_date {
    -webkit-flex-shrink: 0;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    margin-left: 30px;
  }

  &[data-device="mb"] .news_list_item_date {
    display: block;
    margin-top: 5px;
    font-size: 12px;
    line-height: 1;
  }

  &[data-device="mb"] .news_list_item_date {
    margin-left: 0;
  }

  .news_list_item_summery {
    margin-top: 18px;
    font-size: 14px;
    color: #333;
    font-family: Arial;
    line-height: 1.7;
    word-break: normal;
  }

  &[data-device="pc"] .news_list_item_summery {
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    display: -webkit-box;
  }
  &[data-device="pc"][data-type="2"] .news_list_item_summery {
    -webkit-line-clamp: 4;
  }
  &[data-device="pc"][data-type="3"]:first-child .news_list_item_summery{
    -webkit-line-clamp: 4;
  }

  &[data-device="mb"] .news_list_item_summery {
    max-height: 36px;
  }

  &[data-device="mb"] .news_list_item_summery {
    display: -webkit-box;
    max-height: 40px;
    /*line-height: 1.5;*/
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
  }

  &[data-device="mb"] .news_list_item_summery {
    font-size: 12px;
    margin-top: 10px;
  }

  &[data-device="mb"][data-type="4"] .news_list_item_summery {
    word-break: normal;
    white-space: normal;
  }

  .news_list_item_ext_line {
    margin-top: 20px;
  }

  .news_list_item_group {
    display: inline-block;
    width: calc(100% - 40px);
    line-height: 1;
    margin-top: -12px;
  }

  &[data-device="mb"] .news_list_item_group {
    margin-top: -20px;
  }

  &[data-device="mb"][data-type="1"] .news_list_item_group {
    width: 100%;
  }

  &[data-device="mb"][data-type="4"] .news_list_item_group {
    width: 100%;
  }

  .news_list_item_group_item {
    display: inline-block;
    position: relative;
    height: 26px;
    line-height: 24px;
    max-width: 100%;
    padding: 0 8px;
    border: 1px solid #e5e5e5;
    margin-top: 12px;
    margin-right: 15px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    color: #999;
    font-size: 12px;
    word-break: keep-all;
    overflow: hidden;
    z-index: 2;
    text-overflow: ellipsis;
    white-space: nowrap;

  }

  &[data-device="mb"] .news_list_item_group_item {
    height: 26px;
    line-height: 24px;
    padding: 0 8px;
    font-size: 12px;
    margin-right: 12px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }

  .news_list_item_arrow_link {
    max-width: 100%;
    float: right;
    display: block;
    position: relative;
    width: 40px;
    height: 28px;
    overflow: hidden;

    &:before {
      content: "";
      display: inline-block;
      position: absolute;
      left: 0;
      top: 0;
      width: 30px;
      height: 28px;
      background: url("../../../../static/image/vbg01.png") -23px -324px;
      transition: all 0.36s ease;
    }

    &:after {
      content: "";
      display: inline-block;
      position: absolute;
      left: -30px;
      top: 0;
      width: 30px;
      height: 28px;
      background: url("../../../../static/image/vbg01.png") -23px -324px;
      transition: all 0.36s ease;
      opacity: 0;
    }
  }

  .news_list_item_arrow {
    display: none;
  }

  &:hover .news_list_item_arrow_link:before {
    left: 30px;
    opacity: 0;
  }

  &:hover .news_list_item_arrow_link:after {
    left: 0;
    opacity: 1;
  }
}

.basic_article_list_swiper {
  .view_detail_contain {
    margin-top: 15px;
    margin-bottom: 10px;

    .view_detail {
      color: #DA9B0E;
      font-size: 14px;
      width: 100%;
      text-align: center;
      display: block;
      cursor: pointer;
      position: absolute;
      left: 0;
      bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_article_list/components/basic_article.vue